<script lang="ts">
    export let score;
    export let iconWidth;    
</script>

<div class="star-rating">
    <div class="container" style="max-width: {score * 10}%">
        <img
            style="width: {iconWidth * 5}px" 
            src="star-rating.png" alt="star rating"
        >
    </div>
</div>

<style lang="scss">
    .star-rating {
        width: 100%;
        max-width: 100px;
        .container {

            overflow: hidden;
            img {
                max-width: unset;
                height: auto;
                object-fit: contain;
            }
        }
    }
</style>